import {
  FETCH_F1_MENU_ITEMS_PENDING,
  FETCH_F1_MENU_ITEMS_REJECTED,
  FETCH_F1_MENU_ITEMS_FULFILLED,
} from "../../constants/menu";

const footerPartners = (state = {}, action) => {
  switch (action.type) {
    case FETCH_F1_MENU_ITEMS_PENDING:
      return { ...state, loading: true, error: false, success: false };
    case FETCH_F1_MENU_ITEMS_REJECTED:
      return { ...state, loading: false, error: true, success: false };
    case FETCH_F1_MENU_ITEMS_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        f1MenuItems: action.payload.data,
      };
    default:
      return state;
  }
};

export default footerPartners;
